<template>
    <span>
        <div class="toolbar">
            <b-button-group>
                <b-button
                    v-for="tag in tagsList"
                    :key="tag.value"
                    size="sm"
                    variant="light"
                    @mousedown="addTag(tag.value)"
                >
                    {{ tag.name }}
                </b-button>
            </b-button-group>
        </div>
        <b-form-input
            v-on="listeners"
            v-bind="attrs"
            v-if="!isTextArea"
            ref="inputRef"
            :value="inputValue"
            :state="state"
            @input="input"
        ></b-form-input>
        <b-form-textarea
            v-on="listeners"
            v-bind="attrs"
            v-if="isTextArea"
            ref="textAreaRef"
            :value="inputValue"
            :class="['email-message-html-editor', error ? 'is-invalid' : '']"
            :error="error"
            @input="input"
        ></b-form-textarea>
    </span>
</template>

<script>
import { formFieldMixin } from '../../../mixins/form-field-mixin';
import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';

export default {
    name: 'LxEditor',
    mixins: [formFieldMixin, removeScrollMixin],
    props: {
        value: [String, Number],
        tagsList: { type: Array, default: [] },
        isTextArea: { type: Boolean, default: false },
    },
    data() {
        return { range: null, inputValue: this.value };
    },
    methods: {
        addTag(tag) {
            const el = this.isTextArea
                ? this.$refs.textAreaRef
                : this.$refs.inputRef;

            let cursorPos = el.selectionEnd;
            this.inputValue =
                this.value.substring(0, cursorPos) +
                tag +
                this.value.substring(cursorPos);
            cursorPos += tag.length;
            el.focus();

            this.$emit('input', this.inputValue);

            this.$nextTick(() => el.setSelectionRange(cursorPos, cursorPos));
        },
    },
};
</script>

<style lang="scss" scoped>
.toolbar {
    border: 1px solid #ced4da;
    border-bottom: 0;
    box-sizing: border-box;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    padding: 8px;
}

.email-message-html-editor {
    min-height: 150px;
    border: 1px solid #ced4da;
    border-bottom-left-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
    padding: 10px;
    height: auto !important;
}

:deep(.email-message-html-editor a) {
    cursor: pointer !important;
}

:deep(.is-invalid) {
    background-position: top calc(0.375em + 0.1875rem) right
        calc(0.375em + 0.1875rem) !important;
}
</style>
